module.exports = __webpack_public_path__ + "assets/pendo.79344304.svg";